var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _g7, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNotiEmailIcon = function SvgNotiEmailIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1120_4967)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160 79.999C160 124.183 124.184 159.999 80 159.999C35.8163 159.999 0 124.183 0 79.999C0 35.8163 35.8163 0 80 0C124.184 0 160 35.8163 160 79.999Z",
    fill: "#50A5ED"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1120_4967",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 160,
    height: 153
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 156.186H162V4H2V156.186Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1120_4967)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.0147 18.6033C85.9519 18.6033 84.2733 20.2815 84.2733 22.3443C84.2733 24.4071 85.9519 26.0853 88.0147 26.0853C90.0776 26.0853 91.7554 24.4071 91.7554 22.3443C91.7554 20.2815 90.0776 18.6033 88.0147 18.6033ZM88.0147 26.4846C85.7319 26.4846 83.874 24.6271 83.874 22.3443C83.874 20.0615 85.7319 18.2039 88.0147 18.2039C90.2976 18.2039 92.1547 20.0615 92.1547 22.3443C92.1547 24.6271 90.2976 26.4846 88.0147 26.4846Z",
    fill: "#E2F2FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1120_4967",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 160,
    height: 153
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 156.186H162V4H2V156.186Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1120_4967)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.5684 135.054C83.5056 135.054 81.8278 136.733 81.8278 138.796C81.8278 140.858 83.5056 142.537 85.5684 142.537C87.6313 142.537 89.3098 140.858 89.3098 138.796C89.3098 136.733 87.6313 135.054 85.5684 135.054ZM85.5684 142.936C83.2856 142.936 81.4285 141.078 81.4285 138.796C81.4285 136.512 83.2856 134.655 85.5684 134.655C87.8512 134.655 89.7091 136.512 89.7091 138.796C89.7088 141.078 87.8509 142.936 85.5684 142.936Z",
    fill: "#E2F2FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1120_4967",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 160,
    height: 153
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 156.186H162V4H2V156.186Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1120_4967)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.413 75.7073C11.9861 75.7073 10.8296 74.5508 10.8296 73.1238C10.8296 71.6969 11.9861 70.5404 13.413 70.5404C14.84 70.5408 15.9964 71.6973 15.9964 73.1238C15.9964 74.5508 14.84 75.7073 13.413 75.7073Z",
    fill: "#E2F2FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1120_4967",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 160,
    height: 153
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 156.186H162V4H2V156.186Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1120_4967)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.8843 17.7836L68.1984 18.8176L63.9604 19.991L62.9268 24.3054L61.7533 20.0675L57.439 19.0335L61.6769 17.86L62.7109 13.5457L63.8843 17.7836Z",
    fill: "#E2F2FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1120_4967",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 160,
    height: 153
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 156.186H162V4H2V156.186Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1120_4967)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.894 66.9956L149.208 68.0293L144.97 69.2027L143.936 73.5171L142.763 69.2792L138.448 68.2451L142.686 67.0717L143.72 62.7577L144.894 66.9956Z",
    fill: "#E2F2FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1120_4967",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 160,
    height: 153
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2 156.186H162V4H2V156.186Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1120_4967)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.7486 142.14L74.0626 143.174L69.8251 144.348L68.791 148.662L67.6176 144.424L63.3032 143.39L67.5411 142.217L68.5752 137.902L69.7486 142.14Z",
    fill: "#E2F2FF"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1120_4967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.555 70.7352H37V130.876H121.555V70.7352Z",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.788 49.4732H114.146V35.2102C114.146 32.3328 116.481 30 119.361 30C120.801 30 122.106 30.584 123.049 31.5264C123.98 32.4562 124.564 33.7436 124.577 35.1622V35.2102L124.573 44.263C124.573 44.307 124.573 44.3542 124.577 44.3982V44.6725L124.593 44.6646C124.796 47.355 127.044 49.4732 129.788 49.4732Z",
    fill: "#3776AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135 41.1152V44.2669C135 45.7052 134.419 47.0092 133.472 47.9468C132.533 48.8923 131.228 49.4732 129.788 49.4732C127.043 49.4732 124.795 47.355 124.593 44.6646L135 41.116V41.1152Z",
    fill: "#E2F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.361 30C119.25 30 119.143 30.0039 119.035 30.0118C118.963 30.0157 118.896 30.0196 118.828 30.0275C118.752 30.0354 118.681 30.0432 118.605 30.055C118.561 30.0589 118.518 30.0668 118.474 30.0747C118.418 30.0825 118.362 30.0943 118.311 30.1061C118.231 30.1218 118.156 30.1375 118.076 30.158C117.965 30.1855 117.854 30.2177 117.742 30.257C117.686 30.2727 117.63 30.2932 117.579 30.3128C117.527 30.3285 117.471 30.3529 117.42 30.3725C117.345 30.4001 117.273 30.4323 117.202 30.4677C117.138 30.4952 117.074 30.5235 117.01 30.5588C116.995 30.5667 116.974 30.5745 116.954 30.5863C116.899 30.6138 116.843 30.6461 116.788 30.6775C116.569 30.8009 116.358 30.94 116.163 31.0949C116.107 31.1389 116.047 31.186 115.996 31.23C115.932 31.2819 115.877 31.333 115.817 31.3888C115.757 31.4446 115.701 31.5004 115.646 31.5554C115.491 31.7142 115.344 31.8816 115.209 32.06C115.149 32.1394 115.093 32.2149 115.038 32.2942C114.863 32.5607 114.711 32.8389 114.581 33.1329C114.549 33.2044 114.521 33.2798 114.489 33.3553C114.406 33.5817 114.334 33.8167 114.279 34.0548C114.263 34.1381 114.247 34.2175 114.231 34.2969C114.203 34.4596 114.179 34.627 114.167 34.7936V107.879H44.437V38.123C44.437 33.6359 48.0776 30 52.5687 30H119.361H119.361Z",
    fill: "#E2F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.592 37.4471H52.6804V40.2286H105.592V37.4471Z",
    fill: "#3776AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.492 45.5944H52.6804V48.376H101.492V45.5944Z",
    fill: "#3776AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9191 53.741H52.6804V56.5225H98.9191V53.741Z",
    fill: "#3776AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.592 61.8876H52.6804V64.6691H105.592V61.8876Z",
    fill: "#3776AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.813 70.134H73.1274V72.9155H101.813V70.134Z",
    fill: "#3776AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9003 85.7543C78.584 85.7543 78.2921 85.6466 78.0922 85.3715C77.8468 85.032 77.8641 84.5675 77.8759 84.2602L78.1457 77.0717L78.5431 77.0866L78.2732 84.2751C78.2606 84.6099 78.2622 84.9282 78.4148 85.1389C78.7532 85.605 79.5659 85.2018 79.7257 85.1161C80.5266 84.6869 81.1018 83.879 81.6581 83.0977C82.2765 82.2292 82.9162 81.3316 83.8832 80.9096C84.4568 80.6588 84.8793 81.0267 85.2184 81.3199C85.4112 81.4865 85.5929 81.6437 85.7849 81.701C86.2908 81.8504 86.7944 81.7199 87.3271 81.58C87.7976 81.4566 88.2862 81.3285 88.7874 81.4063C89.2461 81.4763 89.6159 81.6586 89.9739 81.8354C90.5027 82.0964 90.9598 82.322 91.6207 82.1616C92.5318 81.9423 93.3785 81.4244 94.1967 80.9229C94.4344 80.7775 94.6704 80.6329 94.9096 80.4938C95.8294 79.9601 97.2126 79.2865 98.588 79.6017L98.499 79.9892C97.2582 79.7063 95.9702 80.3374 95.1087 80.838C94.8726 80.9748 94.6389 81.1186 94.4037 81.2617C93.5586 81.7789 92.6853 82.3141 91.7128 82.5475C90.911 82.7401 90.3437 82.4619 89.7969 82.1915C89.4664 82.0288 89.1242 81.8598 88.7268 81.7993C88.3067 81.7356 87.8794 81.8472 87.427 81.9643C86.8644 82.1113 86.2853 82.263 85.6708 82.0822C85.3962 82.0005 85.172 81.8071 84.9564 81.6201C84.6016 81.3128 84.3679 81.132 84.0406 81.2735C83.1743 81.6515 82.5944 82.4658 81.9807 83.328C81.3976 84.1462 80.7957 84.9927 79.9121 85.4658C79.5982 85.634 79.2339 85.7551 78.8987 85.7551L78.9003 85.7543Z",
    fill: "#AB5998"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M114.165 73.2535V107.879H44.437V70.2377L66.2184 88.3393C67.4198 89.3407 68.995 89.7227 70.5466 89.5034C70.9959 89.4397 71.4578 89.4161 71.9188 89.4279L86.766 89.8453C87.279 89.861 87.7881 89.9246 88.2853 90.0323C89.8251 90.3664 91.4365 90.0598 92.7049 89.1222L114.164 73.2535H114.165Z",
    fill: "#3776AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7929 95.6678L68.2115 96.3115L41.9704 125.377L37.0017 130.878V70.7345L68.7929 95.6678Z",
    fill: "#AB5998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.555 70.7352L89.7629 95.6677L121.555 130.876V70.7352Z",
    fill: "#AB5998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2112 96.3115L41.9702 125.377L37.0015 126.471V115.785C50.1176 106.394 64.8342 95.5051 68.1955 95.2708L68.2112 96.3123V96.3115Z",
    fill: "#6D3061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3452 96.3115L116.586 125.377L121.555 126.47V115.784C108.439 106.393 93.7222 95.5043 90.3609 95.2701L90.3452 96.3115Z",
    fill: "#6D3061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.555 130.876H37L37.0157 122.964L66.1514 96.5614C67.6802 95.1757 69.6709 94.4086 71.7347 94.4086H86.5882C88.6213 94.4086 90.5844 95.1537 92.1053 96.5017L121.638 122.692L121.555 130.877V130.876Z",
    fill: "#AB5998"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1120_4967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1120_4967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 101,
    fill: "white",
    transform: "translate(37 30)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotiEmailIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/noti-email-icon.dbffdc58.svg";
export { ForwardRef as ReactComponent };